module.exports = __webpack_public_path__ + "static/854725372-wide.60e2dbc0.jpg";